import React from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

const AddNewAssistentes: React.FC = () => {
  const { t } = useTranslation("assistants");
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/assistentes/novo');
  };

  return (
    <button
      onClick={handleClick}
      className="min-h-[40px] px-4 bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-[12px] flex justify-center items-center gap-2 shadow-sm transition-colors duration-200"
    >
      <p className="font-medium text-[14px]">{t("list.new")}</p>
      <Plus size={18} className="text-white" />
    </button>
  );
};

export default AddNewAssistentes;
